import { render, staticRenderFns } from "./AudioStatement.vue?vue&type=template&id=4080a7f1&"
import script from "./AudioStatement.vue?vue&type=script&lang=ts&"
export * from "./AudioStatement.vue?vue&type=script&lang=ts&"
import style0 from "./AudioStatement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports